interface Coordinates {
  latitude: number;
  longitude: number;
}
interface MapSize {
  height: number;
  width: number;
}

export const mapCoordinatesToPosition = ({
  coordinates,
  mapSize,
  regionSlug,
}: {
  coordinates: Coordinates;
  mapSize: MapSize;
  regionSlug: 'sicily' | 'puglia';
}) => {
  const regionsCoordinates = {
    puglia: {
      origin: {
        latitude: 41.957011,
        longitude: 14.900135,
      },
      end: {
        latitude: 39.760717,
        longitude: 18.548578,
      },
    },
    sicily: {
      origin: {
        latitude: 38.81728485,
        longitude: 11.92481948,
      },
      end: {
        latitude: 36.64863391,
        longitude: 15.65467788,
      },
    },
  };

  const { origin, end } = regionsCoordinates[regionSlug];

  const mapOrigin = { top: 0, left: 0 };

  const pointCoordinates = {
    top:
      ((coordinates.latitude - origin.latitude) *
        (mapSize.height - mapOrigin.top)) /
        (end.latitude - origin.latitude) +
      mapOrigin.top,
    left:
      ((coordinates.longitude - origin.longitude) *
        (mapSize.width - mapOrigin.left)) /
        (end.longitude - origin.longitude) +
      mapOrigin.left,
  };

  return pointCoordinates;
};
